<template>
    <div id="popup-detail">
        <transition name="modal" v-if="isActive">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <div class="modal-header">
                            <a class="modal-default-button" @click="close">
                                <span><i class="ion-android-close"></i></span>
                            </a>
                        </div>
                         <div class="modal-content">
                             <img :src="media.asset.original" :alt="media.title">
                         </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        props: ['slide'],
        data() {
            return {
                isActive: false,
                media:null,
            }
        },
        methods: {
            show(data){
                this.isActive = !this.isActive;
                this.media = data;
            },
            close(){
                this.isActive = !this.isActive;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
        padding:20px;
    }

    .modal-container {
        width: 50%;
        margin: 0px auto;
        padding: 15px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
    }

    .modal-header h3 {
        margin-top: 0;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        right: -18px;
        top: -18px;
        cursor: pointer;
        background: #000;
        display: block;
        width: 36px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        color: #fff;
        border-radius: 100px;
        position: absolute;
        cursor: pointer;
        span {
            font-size: 20px;
        }
    }
    .modal-default-button:hover{
        background: #E61B33;
    }
    .modal-content{
       img{
          width: 100%;
       }
    }

    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .wrap-box, .wrap-box-thumb {
        border: 1px solid #DBDBDB;
        border-radius: 10px;
        position: relative;
        box-sizing: border-box;
        .wrap-content {
            padding: 20px;
            display: flex;
            justify-content: center;
            .show-img img {
                width: 100%;
            }
        }
    }
    .wrap-content-thumb {
        padding: 10px;
        display: flex;
        justify-content: center;
        cursor: pointer;
    }

    .isActive {
        border: 1px solid #E61B33;
        border-radius: 10px;
        position: relative;
        box-sizing: border-box;
    }
    // ==================================================  MOBILE RESPONSIVE
	@media (max-width: 490px){
        .modal-container{
            width: 100%;
            padding: 15px;
                iframe{
                    height: 300px;
                }
        }
    }
</style>